import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';

import { addSuggestedProduct, updateSuggestedProduct } from '../../actions/product';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import ImageInput from '../ImageInput/ImageInput';
import styles from './SuggestedProductModal.module.css';

const SuggestedProductModal = (props) => {
  const { 
    initialValue, 
    isOpen, 
    onClose,
    addSuggestedProduct,
    updateSuggestedProduct,
    productsData,
  } = props;

  const [name, setName] = useState(''); 
  const [image, setImage] = useState('');

  useEffect(() => {
    if (initialValue) {
      setName(initialValue?.name);
      setImage(initialValue?.image);
    }
  }, [isOpen, initialValue, productsData]);

  const title = initialValue ? 'Edit product' : 'Add new product';

  const changeValueHandler = setter => event => {
    setter(event.target.value);
  };


  const changeImageHandler = (imageData) => {
    // console.log('===CHANGE IMAGE', imageData);
    setImage(imageData);
  };

  // console.log('===image', image);

  const onSaveHandler = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return toast.error('Name is required', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    // Check if there is an product with the same name and unit type
    const existenceProduct = productsData.find(product => {
      if (product.name !== trimmedName) {
        return false;
      }

      return initialValue?.id !== product.id;
    });

    if (existenceProduct) {
      return toast.error('Product with this name already exists', {
        position: 'bottom-right',
        duration: 3000,
      }); 
    }

    const productData = {
      name: trimmedName,
      image,
    };

    let saveProduct = addSuggestedProduct;

    if (initialValue) {
      productData.id = initialValue.id;
      saveProduct = updateSuggestedProduct;
    }

    saveProduct(productData, onClose);
  };

  return (
    <ModalWrapper 
      key={initialValue?.id}
      isOpen={isOpen} 
      onClose={onClose} 
      onSave={onSaveHandler} 
      title={title}
    >
      <div className={styles.wrapper}>
        <label className={styles.row}>
          <span>Product name</span>
          <input 
            className={styles.input} 
            onChange={changeValueHandler(setName)}
            placeholder="Product name"
            value={name}
          />
        </label>
        <div className={styles.dishImages}>
          <div className={styles.dishImagesTitle}>
            Product image
          </div>
          <ImageInput 
            key={initialValue?.id}
            value={image}
            onChange={changeImageHandler}
            name="image"
            label="Upload"
          />
        </div>
      </div>
    </ModalWrapper>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.suggestedProductsData,
});

const mapDispatchToProps = {
  addSuggestedProduct,
  updateSuggestedProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedProductModal);